import { FeatureConfig } from './types'

// Dominari disables impersonation into the storefront; B2B portal
// impersonation remains available.
export const dominari: FeatureConfig = {
  impersonation: {
    storefront: false,
    b2bPortal: true,
  },
}
